<template>
  <div>
  <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h2 class="card-title">Call of Data</h2>
              <p class="category">*Data Viz Project for League of Legends Data*</p>
            </div>
            <div class="card-content">
              <img src="../../../../../static/img/call_of_data_thumbnail.png" alt="An illustration of lips saying 'Use Your Voice'" style="border-radius:30px;margin-bottom:20px">
              <p>This was a class project for Data Visualization at the University of Utah. The data featured is from Call of Duty Worlds (esports) and highlights some interesting team dynamics. The site is live and you can view the data visualiztion for yourself <a href="https://bisberg.me/dataviscourse-pr-call-of-data/viz.html" target="_blank">here</a>.</p>
            </div>
          </div>
        </div>
  </div>

  <!-- Demo Stuff -->
  <div class="row">
      <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Project Demo</h4>
            </div>
            <div class="card-content">
              <p>This was a class project for Data Visualization at the University of Utah. The data featured is from Call of Duty Worlds (esports) and highlights some interesting team dynamics.</p>
              <youtube :video-id="videoIdOne" ref="youtube" @playing="playing"></youtube>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Built With</h4>
            </div>
            <div class="card-content">
              <ul style="font-size:15px">
                <li>D3</li>
                <li>Intro.js</li>
                <li>graph-scroll.js</li>
                <li>Google Fonts</li>
                <li>HTML/CSS/JS</li>
              </ul>
            </div>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  data () {
    return {
      videoIdOne: 'mZSQ4hWBD3I',
      index: null
    }
  },
  methods: {
    playVideo () {
      this.player.playVideo()
    },
    playing () {
      console.log('/\\o/ we are watching!!!')
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    }
  },
  components: {
    'gallery': VueGallery
  }
}
</script>
<style>
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
.image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Projects/CallofData.vue